/* eslint-disable */
export const notifications = {
  namespaced: true,
  state: {
    notification_list: [],
    isLoading: false,
    noread_list: [],
    last_no_read: ""
  },

  mutations: {
    SET_NOTIFICATIONS_LIST(state, payload) {
      state.notification_list = payload;
    },
    SET_LAST_NO_READ(state, payload) {
      state.last_no_read = payload;
    },
    SET_NOREAD_LIST(state, payload) {
      state.noread_list = payload;
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload;
    }
  },

  actions: {
    async loadNotifications({ commit, state, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        let path = `users/${userId}/notifications`;
        let loadCommit = "SET_NOTIFICATIONS_LIST";
        firebase
          .database()
          .ref(path)
          .orderByChild("read")
          .equalTo(false)
          .limitToLast(50)
          .on(
            "value",
            function(snapshot) {
              let items = [];
              if (snapshot.val()) {
                snapshot.forEach(function(child) {
                  items.push({
                    ...child.val(),
                    id: child.key
                  });
                });
                // console.log(items.length)
                /* if (items.length > 100) {
                            firebase.database().ref(path + `/${items[0].id}`).remove()
                        } */
              }
              commit(loadCommit, items.reverse());
              resolve();
            },
            function(error) {
              // console.log(error, 'error notif')
              dispatch("users/showErrorSessionExpired", null, { root: true });
              reject();
            }
          );
      });
    },
    async loadNoRead({ commit, state, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        let path = `users/${userId}/notifications`;
        let loadCommit = "SET_NOREAD_LIST";
        firebase
          .database()
          .ref(path)
          .orderByChild("read")
          .equalTo(false)
          .on(
            "value",
            function(snapshot) {
              let items = [];
              if (snapshot.val()) {
                snapshot.forEach(function(child) {
                  items.push({
                    ...child.val(),
                    id: child.key
                  });
                });
              }
              commit(loadCommit, items);
              resolve();
            },
            function(error) {
              console.error(error);
              dispatch("users/showErrorSessionExpired", null, { root: true });
              reject();
            }
          );
      });
    },
    async listenNewNotifications({ commit, state, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        let loadCommit = "SET_LAST_NO_READ";
        let path = `users/${userId}/notifications`;
        const rightNow = Date.now();
        firebase
          .database()
          .ref(path)
          .on(
            "child_added",
            function(snapshot) {
              let lastNoRead = "";
              if (snapshot.val() && snapshot.val().created > rightNow) {
                lastNoRead = snapshot.val().title;
                commit(loadCommit, lastNoRead);
              }
              resolve();
            },
            function(error) {
              console.error(error);
              dispatch("users/showErrorSessionExpired", null, { root: true });
              reject();
            }
          );
      });
    },
    async UpdateNoRead({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        // console.log(payload)
        let read = {
          read: true
        };
        firebase
          .database()
          .ref(`users/${userId}/notifications/${payload.id}`)
          .update(read);
      });
    },
    async deleteNotification({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        firebase
          .database()
          .ref(`users/${userId}/notifications/${payload.id}`)
          .remove()
          .then(
            function(res) {
              // console.log(res)
              resolve("OK");
            },
            function(error) {
              console.error(error);
              reject();
            }
          );
      });
    }
  },
  getters: {
    getNotifications(state) {
      return state.notification_list;
    },
    getNoRead(state) {
      return state.noread_list;
    },
    getLoading(state) {
      return state.isLoading;
    },
    getLastNoRead(state) {
      return state.last_no_read;
    }
  }
};
